import { render, staticRenderFns } from "./DraftTripDetails.vue?vue&type=template&id=342b1cf8&scoped=true"
import script from "./DraftTripDetails.vue?vue&type=script&lang=js"
export * from "./DraftTripDetails.vue?vue&type=script&lang=js"
import style0 from "./DraftTripDetails.vue?vue&type=style&index=0&id=342b1cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342b1cf8",
  null
  
)

export default component.exports